import React, { useState, useEffect } from 'react'
import Dashboard from 'src/views/dashboard/Dashboard'
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import swal from "sweetalert";
import moment from 'moment';
import {
    CRow,
    CCardFooter,
    CCol,
    CForm,
    CFormGroup,
    CLabel,
    CInput,

} from '@coreui/react'

// import { config } from 'src/utils/apiUrl'
// import { API } from 'src/utils/apiCalling'
import API from '../../utils/apiCalling';
import { config } from '../../utils/apiUrl';

import Moment from "react-moment";



const ViewSelectedComponents = (props) => {
    const { candidateDetails } = props
    let api = new API()
    useEffect(() => {
  
    }, [])

    return (
        <div className="">

            <CForm action="" encType="multipart/form-data" className="form-horizontal">

                <CRow>
                    <CCol md="6">

                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >Candidate ID</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled  value={candidateDetails && candidateDetails.c_id} name="id" placeholder="" />
                            </CCol>
                        </CFormGroup>
                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >Name</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled value={candidateDetails && candidateDetails.name} name="name" placeholder="" />
                            </CCol>
                        </CFormGroup>
                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >Email</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled value={candidateDetails && candidateDetails.email} name="email" placeholder="" />
                            </CCol>
                        </CFormGroup>
                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >DOB</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled value={candidateDetails && candidateDetails.dob} name="dob" placeholder="" />
                            </CCol>
                        </CFormGroup>
                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >Designation</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled value={candidateDetails && candidateDetails.designation} name="designation" placeholder="" />
                            </CCol>
                        </CFormGroup>
                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >Mobile</CLabel>
                            </CCol>

                            <CCol xs="12" md="9">
                                <CInput disabled value={candidateDetails && candidateDetails.mobile} name="mobile" placeholder="" />
                            </CCol>
                        </CFormGroup>
                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >Address</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled value={candidateDetails && candidateDetails.address ? candidateDetails?.address : candidateDetails?.current_location} name="address" placeholder="" />
                            </CCol>
                        </CFormGroup>
                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >Pin Code</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled value={candidateDetails && candidateDetails.pincode} name="pincode" placeholder="" />
                            </CCol>
                        </CFormGroup>
                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >Experience</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled value={candidateDetails && candidateDetails.experience} name="experience" placeholder="" />
                            </CCol>
                        </CFormGroup>

                    </CCol>
                    <CCol md="6">

                    <CFormGroup row>
                            <CCol md="3">
                                <CLabel >Knowledge</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled value={(candidateDetails && candidateDetails?.technology_knowledge) || ''} name="technology_knowledge" placeholder="" />
                            </CCol>
                        </CFormGroup>

                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >MRF ID</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled value={candidateDetails && candidateDetails.mrf} name="mrf_id" placeholder="" />
                            </CCol>
                        </CFormGroup>
                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >Applying For</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled value={candidateDetails && candidateDetails.mrf_applying_for=="vacancy"?"New Hiring":candidateDetails && candidateDetails.mrf_applying_for} name="mrf_applying_for" placeholder="" />
                            </CCol>
                        </CFormGroup>

                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >MRF Raised By</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled value={candidateDetails && candidateDetails.mrf_raised_by} name="mrf_raised_by" placeholder="" />
                            </CCol>
                        </CFormGroup>

                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >Created By</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled value={candidateDetails && candidateDetails.candidate_created_by} name="candidate_created_by" placeholder="" />
                            </CCol>
                        </CFormGroup>
                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >Interview Status</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled value={(candidateDetails && candidateDetails?.interview_round === '1' && candidateDetails?.interview_selection_status === 1 && candidateDetails?.overall_interview_status === 0) ? "1 Round Completed" : (candidateDetails && candidateDetails.interview_round === '1' && candidateDetails?.interview_rejection_status === 1) ? "1 Round Rejected" : (candidateDetails && candidateDetails?.overall_interview_status === 1) ? "Completed" : "Pending"} name="status" placeholder="" />
                            </CCol>
                        </CFormGroup>

                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >Overall Status</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled value={candidateDetails && candidateDetails.overall_interview_status===0?"Pending":"Complete"} name="overall_interview_status" placeholder="" />
                            </CCol>
                        </CFormGroup>

                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >Offer Letter</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                                <CInput disabled value={candidateDetails && candidateDetails.is_offer_letter_status==0?"Not Send":"Send"} name="is_offer_letter_status" placeholder="" />
                            </CCol>
                        </CFormGroup>
                        <CFormGroup row>
                            <CCol md="3">
                                <CLabel >Created At</CLabel>
                            </CCol>


                            <CCol xs="12" md="9">
                            <CInput disabled 
                            value={candidateDetails && moment(candidateDetails.created_at).format("DD MMM YYYY HH:mm A")} name="is_offer_letter_status" placeholder="" />
                               
                            </CCol>
                        </CFormGroup>

                    </CCol>
                </CRow>



                {/* <CCardFooter>
                    {/* <CButton type="button" className="btn btn-primary mr-3 mt-2">Load Details</CButton> */}

                {/* </CCardFooter> */} 

            </CForm>

        </div>

    )
}
export default ViewSelectedComponents







